import React from "react";
import { useLocation } from "wouter";

import { FilterableSuppliers } from "components/suppliers/FilterableSuppliers";
import { BASELINE_SUPPLIER_COLUMNS, SupplierFilters } from "components/suppliers/utils";
import { useSavedSuppliers } from "lib/hooks/api/signals/useSavedSuppliers";
import { BuyerSummary } from "lib/types/models";
import { SecondaryTab } from "./types";

type Props = { buyer: BuyerSummary };

function getSelectedTab(url: string) {
  switch (url) {
    case SecondaryTab.PARTNERS:
      return SecondaryTab.PARTNERS;
    case SecondaryTab.COMPETITORS:
      return SecondaryTab.COMPETITORS;
    default:
      return SecondaryTab.SUPPLIERS;
  }
}

export function SupplierTab({ buyer }: Props) {
  const [location] = useLocation();

  const DEFAULT_BUYER_SUPPLIER_FILTERS: SupplierFilters = {
    buyerIds: [buyer.guid],
    signals: [],
    text: "",
    sort: { field: "signals", order: "DESC" },
  };

  const { data: savedSuppliers } = useSavedSuppliers({
    enabled: !window.guestUser,
  });

  const currentSelectedTabFilters = (): SupplierFilters => {
    const loc = getSelectedTab(location);

    switch (loc) {
      case SecondaryTab.COMPETITORS: {
        return {
          ...DEFAULT_BUYER_SUPPLIER_FILTERS,
          guids: savedSuppliers?.competitorGuids,
        };
      }

      case SecondaryTab.PARTNERS: {
        return {
          ...DEFAULT_BUYER_SUPPLIER_FILTERS,
          guids: savedSuppliers?.partnerGuids,
        };
      }

      default: {
        return DEFAULT_BUYER_SUPPLIER_FILTERS;
      }
    }
  };
  return (
    <FilterableSuppliers
      defaultFilters={currentSelectedTabFilters()}
      hiddenFilterSections={["buyers", "lots", "signals"]}
      defaultColumns={BASELINE_SUPPLIER_COLUMNS.filter((c) => c.field !== "upcomingExpiries")}
      linkToBuyerRelationshipPage={{ buyerGuid: buyer.guid }}
    />
  );
}
